import { AfterViewInit, OnDestroy, ViewChild, Component, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import * as mail from '@sendgrid/mail';
import { SharedService } from 'src/app/shared.service';
import { AppConfigService } from 'src/app/app-config.service';
@Component({
  selector: 'app-employee-view-report',
  templateUrl: './employee-view-report.component.html',
  styleUrls: ['./employee-view-report.component.scss']
})
export class EmployeeViewReportComponent implements OnInit {
  constructor(private service: SharedService, private appSettings: AppConfigService) {
  }
  summaryList: any = [];
  Date: any;
  month: any = 'January';
  monthDropdown =
    [
      { Value: 1, Text: 'January' },
      { Value: 2, Text: 'February' },
      { Value: 3, Text: 'March' },
      { Value: 4, Text: 'April' },
      { Value: 5, Text: 'May' },
      { Value: 6, Text: 'June' },
      { Value: 7, Text: 'July' },
      { Value: 8, Text: 'August' },
      { Value: 9, Text: 'September' },
      { Value: 10, Text: 'October' },
      { Value: 11, Text: 'November' },
      { Value: 12, Text: 'December' }
    ]
  monthNum: any = new Date().getMonth() + 1;
  year: any = new Date().getFullYear();
  yearDropdown: number[] = [];
  empId!: number;
  employee: any;
  ngOnInit(): void {
    var currentYear = new Date().getFullYear();
    this.yearDropdown = [];
    for (let yearItem = this.appSettings.getStartYear(); yearItem <= currentYear; yearItem++) {
      this.yearDropdown.push(yearItem);
    }
    this.service.currentEmployee.subscribe(data => {
      this.employee = data;
      this.empId = this.employee.pkEmpId;
      this.RefreshSummaryList();
    });
    this.Date = this.GetCurrentDate();
  }
  Test() {
    console.log(this.empId);
    console.log(this.year);
    console.log(this.summaryList);
  }
  GetEmployee(id: number) {
    this.service.GetEmployee(id).subscribe(data => {
      this.employee = data
    });
  }
  GetCurrentDate() {
    let today = new Date().toISOString().slice(0, 10)
    return today
  }
  RefreshSummaryList() {
    this.service.GetSummariesForYear(this.empId, this.year).subscribe(data => {
      this.summaryList = data
    });
  }
  UpdateYear(year: number) {
    this.year = year;
    this.RefreshSummaryList();
  }
}